// Roles individuales
export const Roles = {
//IperC
Admin: "Admin",
Instructor: "Instructor",
SupervisorCampo: "lv.SupervisorCampo",
SupervisorMantenimiento: "lv.SupervisorMantenimiento",
SsomaAdmin: "ssoma.admin",
SupervisorSeguridad: "SupervisorSeguridad",
};

// Roles agrupados por rutas
export const RolesRuta = {
    
// IperC - Base
IPERC_BASE:[
    Roles.Admin,
    Roles.SsomaAdmin,
],

// IperC - Cuadro de Mando
IPERC_CM:[
    Roles.Admin,
    Roles.SupervisorCampo,
    Roles.SsomaAdmin,
    Roles.SupervisorSeguridad,
],

// IperC - CheckList
IPERC_CHECKLIST:[
    Roles.Admin,
    Roles.SsomaAdmin,
],

// IperC - Configuraciones
IPERC_CONFIGURACIONES:[
    Roles.Admin,
    Roles.Instructor,
    Roles.SsomaAdmin,
],

// ListaVerificacion - Cuadro de Mando
LISTAVERIFICACION_CM:[
    Roles.Admin,
    Roles.SupervisorCampo,
    Roles.SsomaAdmin,
    Roles.SupervisorSeguridad,
],

// ListaVerificacion - Historial
LISTAVERIFICACION_HISTORIAL:[
    Roles.Admin,
    Roles.Instructor,
    Roles.SupervisorCampo,
    Roles.SupervisorMantenimiento,
    Roles.SsomaAdmin,
    Roles.SupervisorSeguridad,
],

// ListaVerificacion - Mantenimiento
LISTAVERIFICACION_MANTENIMIENTO:[
    Roles.Admin,
    Roles.SupervisorMantenimiento,
    Roles.SsomaAdmin,
],

// Reportes
REPORTES:[
    Roles.Admin,
    Roles.SsomaAdmin,
],
};
